import React from "react";
import { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";

export default function AioHeader({ darkMode }) {
    const navigate = useNavigate();

    return (
        <header
            className="newHeader blueHeader"
            style={{ backgroundColor: darkMode ? "#171717" : "#fff" }}
        >
            <Toaster position="top-center" />
            <div className="container-fluid">
                <div className="row d-flex align-items-center justify-content-center">
                    <div className="d-flex align-items-center justify-content-center" style={{ padding: "20px 0" }}>
                        <a
                            onClick={() => navigate("/")}
                            style={{ cursor: "pointer" }}
                        >
                            <img
                                style={{
                                    filter: !darkMode
                                        ? "brightness(0)"
                                        : "unset",
                                }}
                                src="https://images.ctfassets.net/1itkm9rji8jb/48jN6KXbjOANg70fZ2oHFE/66ead803c36b23e6752a0a2602e659bc/logo__1_.png"
                                alt="Logo"
                            />
                        </a>
                    </div>
                </div>
            </div>
        </header>
    );
}
